import(/* webpackMode: "eager" */ "/vercel/path0/src/app/try/gojuon/practice/page.tsx");
